import React, { Component } from 'react';
import CurrentOrganizationStore from '../../stores/CurrentOrganizationStore';
import AvailableRolesStore from '../../stores/AvailableRolesStore';
import AvailableTableauUsersStore from '../../stores/AvailableTableauUsersStore';
import { Container } from 'flux/utils';
import NewUser from './NewUser.react';

class NewUserContainer extends Component {
  static getStores() {
    return [CurrentOrganizationStore, AvailableRolesStore];
  }

  static calculateState() {
    return {
      organization: CurrentOrganizationStore.getState(),
      availableRoles: AvailableRolesStore.getState(),
      availableTableauUsers: AvailableTableauUsersStore.getState()
    };
  }

  render() {
    if (this.state.availableRoles) {
      return (
        <NewUser
          organization={this.state.organization}
          availableRoles={this.state.availableRoles}
          availableTableauUsers={this.state.availableTableauUsers}
        />);
    }
    return null;
  }
}

const container = Container.create(NewUserContainer);

export default container;
